<template>
  <div class="chat-footer" v-if="summaryStatus === 'ready' && actionState === 'summary'">
    <div class="actions-container">
      <div class="summary-actions">
        <div class="thumbs-wrapper">
          <div class="thumb-btn-wrapper">
            <button
              class="thumb-btn thumb-down"
              :class="{ active: ratting === false }"
              :disabled="ratting === false"
              data-dd-action-name="noa_summary_thumbs_down"
              @click="handleThumbsDownClick"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"
                />
                <path d="M17 14V2" />
              </svg>
            </button>
            <span class="thumb-tooltip">Thumbs down</span>
          </div>
          <div class="thumb-btn-wrapper">
            <button
              class="thumb-btn thumb-up"
              :class="{ active: ratting === true }"
              :disabled="ratting === true"
              data-dd-action-name="noa_summary_thumbs_up"
              @click="handleThumbsUpClick"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
                />
                <path d="M7 10v12" />
              </svg>
            </button>
            <span class="thumb-tooltip">Thumbs up</span>
          </div>
        </div>
      </div>
      <div class="summary-actions">
        <w-button
          :loading="stateSavingSummary"
          label="Fechar"
          variant="neutral"
          @click="onClickClose"
          class="close-button"
          data-dd-action-name="noa_summary_close"
        />
        <w-button
          :loading="stateSavingSummary"
          :disabled="!hasChanges"
          leading-icon="check"
          label="Aceitar e salvar resumo"
          :variant="!hasChanges ? 'neutral' : 'primary'"
          :style="!hasChanges ? 'cursor: not-allowed;' : ''"
          @click="onClickSaveSummary"
          class="save-button"
          data-dd-action-name="noa_summary_save"
        />
      </div>
    </div>

    <div v-if="isAlfa && !isPreemium && preemiumConfig.active">
      <w-badge :type="freemiumLimitExceeded ? 'danger' : 'neutral'" class="freemium-badge">
        <span v-text="freemiumExceededMessage"></span>
      </w-badge>

      <w-button
        v-if="freemiumLimitExceeded"
        class="pro-button"
        label="Desbloquear Plano Pro"
        :loading="stateSavingSummary"
        href="https://feegowclinic.com.br/software-para-dentistas-0?hs_preview=YHApGUcG-183768869505"
        target="_blank"
        variant="plain"
        leading-icon="star"
      />
    </div>

    <!-- Thumbs Down Feedback Popover -->
    <div v-if="showThumbsDownModal" class="thumbs-down-overlay" @click.self="cancelThumbsDown">
      <div class="thumbs-down-popover">
        <div class="thumbs-down-header">
          <span class="thumbs-down-title">O que podemos melhorar?</span>
          <button class="thumbs-down-close" @click="cancelThumbsDown">&times;</button>
        </div>
        <p class="thumbs-down-description">Conte-nos o que não ficou bom no resumo.</p>
        <textarea
          v-model="thumbsDownComment"
          rows="3"
          placeholder="Escreva seu comentário aqui..."
          class="thumbs-down-textarea"
        ></textarea>
        <div class="thumbs-down-footer">
          <w-button variant="outlined" label="Cancelar" @click="cancelThumbsDown" />
          <w-button variant="filled" label="Enviar" @click="submitThumbsDown" />
        </div>
      </div>
    </div>

    <w-toast :toasts="toastsData" />

    <!-- Confirmation Modal for Leaving Without Saving -->
    <w-modal
      v-model="showCloseConfirmationModal"
      size="medium"
      title="Sair sem salvar?"
      :close-on-click-outside="false"
      style="z-index: 99999999999"
      class="close-confirmation-modal"
    >
      <template #body>
        <div style="padding: var(--w-space-sm)">
          <w-text type="body" tag-type="p">
            Você não salvou este resumo. Se sair agora, este resumo será descartado.
          </w-text>
        </div>
      </template>
      <template #footer>
        <div style="display: flex; gap: var(--w-space-s); justify-content: flex-end; padding: var(--w-space-sm)">
          <w-button
            label="Cancelar"
            variant="neutral"
            @click="showCloseConfirmationModal = false"
            data-dd-action-name="noa_summary_close_cancel"
          />
          <w-button
            label="Descartar"
            variant="danger"
            @click="confirmClose"
            data-dd-action-name="noa_summary_discard_confirm"
          />
        </div>
      </template>
    </w-modal>

    <!-- Confirmation Modal for Saving Summary -->
    <w-modal
      v-model="showSaveConfirmationModal"
      size="medium"
      title="Salvar resumo?"
      :close-on-click-outside="false"
      style="z-index: 99999999999"
      class="save-confirmation-modal"
    >
      <template #body>
        <div style="padding: var(--w-space-sm)">
          <w-text type="body" tag-type="p">
            Ao salvar, o resumo será enviado para o prontuário do paciente e <b>um formulário será gerado.</b> Esta ação
            não pode ser desfeita.
          </w-text>
          <w-text type="body" tag-type="p" style="margin-top: var(--w-space-s)"> Deseja continuar? </w-text>
        </div>
      </template>
      <template #footer>
        <div style="display: flex; gap: var(--w-space-s); justify-content: flex-end; padding: var(--w-space-sm)">
          <w-button label="Cancelar" variant="neutral" @click="showSaveConfirmationModal = false" />
          <w-button label="Salvar resumo" variant="primary" @click="confirmSaveSummary" />
        </div>
      </template>
    </w-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, inject, computed, watch } from "vue";
import { UserTracking } from "@/utils/UserTracking";
import { trackNoaRumAction, NOA_RUM_EVENT } from "@/utils/noaObservability";
import { useStateMachine } from "@/composables/useStateMachine";
import { useSessionStore } from "@/composables/useSessionStore";

const machine = useStateMachine();
const sessionStore = useSessionStore();

const props = defineProps({
  summaryStatus: {
    type: String,
    required: true,
  },
  reviewStatus: {
    type: String,
    required: true,
  },
  actionState: {
    type: String,
    required: true,
  },
  initialContext: {
    type: Object,
    required: true,
  },
  customForms: {
    type: Array,
    required: true,
  },
  preemiumConfig: {
    type: Object,
    required: true,
  },
  summaryText: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["summarySaved", "summaryDenied", "close"]);

const apiClient = inject<{
  post: (url: string, data: any) => Promise<any>;
  put: (url: string, data: any) => Promise<any>;
}>("apiClient");
const ratting = ref(null);
const showThumbsDownModal = ref(false);
const thumbsDownComment = ref("");

const handleThumbsUpClick = () => {
  ratting.value = true;
  sendRattingToBackend();
};

const handleThumbsDownClick = () => {
  showThumbsDownModal.value = true;
  ratting.value = false;
};

const submitThumbsDown = () => {
  sendRattingToBackend();
  showThumbsDownModal.value = false;
  thumbsDownComment.value = "";
};

const cancelThumbsDown = () => {
  showThumbsDownModal.value = false;
  thumbsDownComment.value = "";
  ratting.value = null;
};

const sendRattingToBackend = async () => {
  try {
    await apiClient.post(`/session/${props.initialContext.recorderSessionId}/summary/rating`, {
      rating: ratting.value ? "Like" : "Dislike",
      comment: thumbsDownComment.value,
    });
    toastsData.value = [
      {
        content: "Feedback enviado com sucesso!",
        variant: "default",
        timeOut: 3000,
      },
    ];
  } catch (error) {
    console.error("Failed to send ratting to backend:", error);
    toastsData.value = [
      {
        content: "Erro ao enviar feedback.",
        variant: "error",
        timeOut: 3000,
      },
    ];
    ratting.value = null;
  }
};

const loadingFormGenerate = ref(false);
const stateSavingSummary = ref(false);
const disableButtonGenerateDocument = ref(props.reviewStatus === "pending" ? true : false);
const toastsData = ref([]);
const originalText = ref("");
const hasChanges = ref(false);
const showCloseConfirmationModal = ref(false);
const showSaveConfirmationModal = ref(false);

const isAlfa = computed(() => props.initialContext.licenseId === 17973 || props.initialContext.licenseId === 9326);
const isPreemium = computed(() => props.initialContext.isPreemium);

// Initialize state based on review status only (not text changes)
watch(
  () => props.reviewStatus,
  (newStatus) => {
    if (newStatus === "pending") {
      disableButtonGenerateDocument.value = true;
      originalText.value = ""; // For pending reviews, no original text yet
      hasChanges.value = true; // Allow saving without edits for new reviews
    } else if (newStatus === "reviewed") {
      disableButtonGenerateDocument.value = false;
      originalText.value = props.summaryText || ""; // Set current text as original for reviewed
      hasChanges.value = false; // No changes initially for reviewed summaries
    }
  },
  { immediate: true },
);

const freemiumRemainingDays = computed(() =>
  Math.ceil((new Date().getTime() - new Date(props.preemiumConfig.releaseDate).getTime()) / (1000 * 60 * 60 * 24)),
);
const freemiumLimitExceeded = computed(() =>
  props.preemiumConfig.active && props.preemiumConfig.mode === "time"
    ? freemiumRemainingDays.value >= props.preemiumConfig.limit
    : !isPreemium.value && props.initialContext.transcriptionsThisMonth >= props.preemiumConfig.credits,
);

const freemiumExceededMessage = computed(() => {
  if (props.preemiumConfig.active && props.preemiumConfig.mode === "time") {
    if (freemiumLimitExceeded.value) {
      return "Seu período de teste acabou!";
    }
    return `${props.preemiumConfig.limit - freemiumRemainingDays.value} dias do Pro restantes`;
  }
  return `${props.initialContext.transcriptionsThisMonth}/${props.preemiumConfig.credits} resumos grátis este mês`;
});

// Helper function to normalize text for comparison (handle HTML differences)
const normalizeText = (text) => {
  if (!text) return "";
  return text
    .replace(/\s+/g, " ") // Normalize whitespace
    .replace(/<p><\/p>/g, "") // Remove empty paragraphs
    .replace(/<p><br><\/p>/g, "") // Remove empty paragraphs with line breaks
    .trim();
};

// Watch for text changes after initialization
watch(
  () => props.summaryText,
  (newText, oldText) => {
    const normalizedNew = normalizeText(newText);
    const normalizedOriginal = normalizeText(originalText.value);

    // For pending reviews, always allow save (first save)
    if (props.reviewStatus === "pending") {
      hasChanges.value = true;
    } else if (props.reviewStatus === "reviewed") {
      // For reviewed summaries, check if text actually changed from the saved version
      const textChanged = normalizedNew !== normalizedOriginal;
      hasChanges.value = textChanged;
    }
  },
);

// Update original text when review status changes to reviewed
watch(
  () => props.reviewStatus,
  (newStatus, oldStatus) => {
    if (newStatus === "reviewed" && oldStatus === "pending") {
      originalText.value = props.summaryText;
      hasChanges.value = false;
      disableButtonGenerateDocument.value = false;
    }
  },
);

const onClickSaveSummary = () => {
  if (!hasChanges.value) {
    return;
  }
  // Show save confirmation modal
  showSaveConfirmationModal.value = true;
};

const confirmSaveSummary = async () => {
  showSaveConfirmationModal.value = false;
  stateSavingSummary.value = true;
  machine.setSummarySaving(true);
  try {
    const response = await apiClient.put(`/session/${props.initialContext.recorderSessionId}`, {
      summary: props.summaryText,
      status: "Verified",
    });

    // Track BEFORE eval(jsCommand) — `reloadTimeline()` can destroy the Vue
    // iframe before async-tracking calls flush. See docs/ehr/known-issues.md
    // item #10 ("reviewed without noa_notes_added in Amplitude").
    UserTracking.trackEvent("noa_notes_added", {
      page_category: "noa notes",
      page_section: "",
    });
    trackNoaRumAction(NOA_RUM_EVENT.SUMMARY_ACCEPTED, {
      session_id: props.initialContext.recorderSessionId ?? "unknown",
      save_path: "summary_footer",
    });

    if (response.jsCommand) {
      sessionStore.setReloadTimeline(response.jsCommand);
      eval(response.jsCommand);
    }

    stateSavingSummary.value = false;
    disableButtonGenerateDocument.value = false;
    originalText.value = props.summaryText;
    hasChanges.value = false;

    machine.send({ type: "WS_VERIFIED" });
    machine.setSummarySaving(false);
    emit("summarySaved");
  } catch (error) {
    toastsData.value = [
      {
        content: "Erro ao salvar resumo.",
        variant: "error",
        timeOut: 3000,
      },
    ];
    machine.setSummarySaving(false);
    stateSavingSummary.value = false;
  }
};

const onClickClose = () => {
  // If there are unsaved changes, show confirmation modal
  if (hasChanges.value) {
    showCloseConfirmationModal.value = true;
  } else {
    // No changes, just close
    emit("close");
  }
};

const confirmClose = async () => {
  // Close modal first
  showCloseConfirmationModal.value = false;

  try {
    await apiClient.put(`/session/${props.initialContext.recorderSessionId}`, {
      summary: props.summaryText,
      status: "Discarded",
    });
    trackNoaRumAction(NOA_RUM_EVENT.SUMMARY_DISCARDED, {
      session_id: props.initialContext.recorderSessionId ?? "unknown",
      had_changes: hasChanges.value,
    });
  } catch (error) {
    console.error("[SummaryFooter] Error discarding session:", error);
    toastsData.value = [
      {
        content: "Erro ao descartar resumo.",
        variant: "error",
        timeOut: 3000,
      },
    ];
    return;
  }

  // Emit close/discard after API call
  emit("summaryDenied");
};
</script>

<style scoped lang="scss">
.chat-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: #fff;
  padding: 12px;
  border-top: 1px solid #ccc;
  width: 100%;
  box-sizing: border-box;
}

/* Popover specific styles */
:deep(.popover-body) {
  .chat-footer {
    position: relative;
    width: 100%;
    bottom: auto;
    left: auto;
    right: auto;
  }
}

.actions-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  max-width: 100%;
}

.summary-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.freemium-badge {
  font-size: 10px;
  margin-right: 9px;
}

.pro-button {
  margin-left: 10px;
}

.save-button {
  font-weight: 600;
  min-width: 200px;
}

.close-button {
  font-weight: 600;
}

.thumbs-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.thumb-btn-wrapper {
  position: relative;
  display: inline-flex;

  &:hover .thumb-tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateX(20%) translateY(-10%);
  }
}

.thumb-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  padding: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #f3f4f6;
    color: #374151;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:disabled.active {
    opacity: 1;
  }

  &.thumb-down {
    svg {
      margin-top: 10px;
      color: #fd648d;
    }
    &.active svg {
      color: #a30404;
      fill: #c9392d;
    }
  }

  &.thumb-up {
    svg {
      color: #007c68;
    }
    &.active svg {
      color: #007c68;
      fill: #059669;
    }
  }
}

.thumb-tooltip {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(0) translateY(0);
  background: #1f2937;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 99999999;
  pointer-events: none;

  &::after {
    content: "";
    position: absolute;
    top: 38%;
    left: -10%;
    transform: translateY(0);
    border: 5px solid transparent;
    border-right-color: #1f2937;
  }
}

.thumbs-down-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
}

.thumbs-down-popover {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
  padding: 16px;
  width: 320px;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.thumbs-down-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.thumbs-down-title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
}

.thumbs-down-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #9ca3af;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;

  &:hover {
    color: #374151;
  }
}

.thumbs-down-description {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

.thumbs-down-textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  min-height: 60px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #059669;
    box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.15);
  }
}

.thumbs-down-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>

<style>
/* Ensure confirmation modals appear above all other modals */
.close-confirmation-modal,
.save-confirmation-modal {
  z-index: 99999999999 !important;
}

.close-confirmation-modal .w-modal-backdrop,
.save-confirmation-modal .w-modal-backdrop {
  z-index: 99999999998 !important;
}

.close-confirmation-modal .w-modal-popout,
.save-confirmation-modal .w-modal-popout {
  z-index: 99999999999 !important;
  position: relative;
}

/* Target the modal wrapper */
:deep(.close-confirmation-modal),
:deep(.save-confirmation-modal) {
  z-index: 99999999999 !important;
}

:deep(.close-confirmation-modal .w-modal-backdrop),
:deep(.save-confirmation-modal .w-modal-backdrop) {
  z-index: 99999999998 !important;
}

:deep(.close-confirmation-modal .w-modal-popout),
:deep(.save-confirmation-modal .w-modal-popout) {
  z-index: 99999999999 !important;
}
</style>
